import React, { useState } from "react";
import "./FaqAccordion.css";

const FAQ_ITEMS = [
  {
    q: "Is RoadDogg AI free to use?",
    a: "Yes! RoadDogg AI is free to download and use. The core features — AI assistant, maps, activity logging, and weather — are available on the free tier. A Pro subscription unlocks advanced AI capabilities, higher usage limits, and exclusive features.",
  },
  {
    q: "Does the app work without an internet connection?",
    a: "Some features like your saved logs, notes, and previously cached map data are accessible offline. However, the AI assistant, live weather, and real-time map data require an active internet connection to function.",
  },
  {
    q: "How do I cancel my Pro subscription?",
    a: "Subscriptions are managed through the App Store (iOS) or Google Play (Android). To cancel, go to your device's subscription settings, find RoadDogg AI Pro, and select Cancel Subscription. Your access continues until the end of the current billing period.",
  },
  {
    q: "Is my location data private?",
    a: "Absolutely. We collect location only while you're actively using location-based features. We never sell or share your location data with advertisers or data brokers. You can review our full Privacy Policy for complete details on how location data is handled.",
  },
  {
    q: "The AI gave me incorrect information. What should I do?",
    a: "AI assistants can occasionally make mistakes. For critical decisions involving safety, regulations, or legal matters, always verify information with official sources. Please report any significant AI errors via the contact form so our team can improve the system.",
  },
  {
    q: "How do I enable the App Lock feature?",
    a: "Go to Settings → App Preferences → Privacy, then enable App Lock. You can set up Face ID, Touch ID, or a passcode. Once enabled, the app will require authentication before showing your data, even if your phone is unlocked.",
  },
  {
    q: "Can I export my driving logs?",
    a: "Log export functionality is available for Pro subscribers. From your File Cabinet, you can export logs as PDF or CSV for record-keeping or sharing with dispatchers and fleet managers.",
  },
];

export default function FaqAccordion() {
  const [openIdx, setOpenIdx] = useState(null);

  const toggle = (idx) => setOpenIdx(openIdx === idx ? null : idx);

  return (
    <div className="faq-wrap">
      <div className="faq-inner">
        <h2>Frequently Asked Questions</h2>

        {FAQ_ITEMS.map((item, idx) => (
          <div key={idx} className="faq-item">
            <button className="faq-q" onClick={() => toggle(idx)}>
              <span>{item.q}</span>
              <div className={`faq-chevron ${openIdx === idx ? "open" : ""}`}>
                ▾
              </div>
            </button>
            <div className={`faq-a ${openIdx === idx ? "open" : ""}`}>
              {item.a}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
